// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__BK1dv","IsLarge":"Loader_IsLarge__IwYMY"};